import { render, staticRenderFns } from "./ClientRelationshipManager.vue?vue&type=template&id=fba144ee&scoped=true&"
import script from "./ClientRelationshipManager.vue?vue&type=script&lang=ts&"
export * from "./ClientRelationshipManager.vue?vue&type=script&lang=ts&"
import style0 from "./ClientRelationshipManager.vue?vue&type=style&index=0&id=fba144ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fba144ee",
  null
  
)

export default component.exports